function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import componentPropType from '@signal/prop-types/component';
import Button from '../Button';
import { usePopover } from '../Popover/Context';
export function PopoverTrigger(_ref) {
  var Component = _ref.component,
      props = _objectWithoutProperties(_ref, ["component"]);

  var _usePopover = usePopover(),
      handleOpen = _usePopover.handleOpen,
      triggerRef = _usePopover.triggerRef;

  return /*#__PURE__*/React.createElement("span", {
    ref: triggerRef,
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/React.createElement(Component, Object.assign({
    onClick: handleOpen,
    "aria-haspopup": true
  }, props)));
}
PopoverTrigger.defaultProps = {
  component: Button
};
PopoverTrigger.propTypes = {
  component: componentPropType
};
export default PopoverTrigger;